import React from 'react'

export default function ArticleFooter(props) {
    return (
        <></>
    )
  }